<template>
    <div class="YaSiRegular">
<!--        <h2 class="scr-title animate fadeInUp" >Trayton Group aligns our efforts<br>-->
<!--            with the UN SDGs<br>-->
<!--            (UN Sustainable Development Goals)</h2>-->
<!--        <img class="csr1 animate opacityIn" src="../../../assets/images/csr1.jpg" alt="csr1">-->
        <div class="csr-2 ">
            <swiper class="left swiper-box animate opacityIn"  :options="swiperOptions1" >
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_01.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_02.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_03.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_04.jpg" alt="csr1">
                    </div>
                </swiper-slide>
              <swiper-slide >
                <div class="swiper-img">
                  <img src="../../../assets/images/csr_swiper_01_07.jpg" alt="csr1">
                </div>
              </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_05.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_06.jpg" alt="csr1">
                    </div>
                </swiper-slide>
            </swiper>
            <div class="right">
                <div class="animate fadeInRight">
                    <h2 >我们的员工</h2>
                    <p >为特雷通工作，我们感到非常自豪，我们培育了高品质和高度责任感的企业文化。在特雷通，每一个人关注并承担提高产品品质、降低成本和高效生产的责任。通过我们国际化的团队中凝聚起的独特实践经验，我们共同创建了一个拥有可持续发展能力和竞争力的特雷通。我们有共同的热情，对客户的需求、对地球、对员工有深切的关怀。我们独特的业务管理模式让每个人都参与其中——在一个非常扁平的组织中，每个人都深知自己的目标和原则，并深感自身是公司成功的一部分。</p>
                </div>
            </div>
        </div>
        <div class="csr-2">
            <div class="right">
                <div class="animate fadeInLeft">
                    <div class="row-1 ">
                        <img class="img" src="../../../assets/images/csr3.png" alt="">
<!--                        <h2 class="" >我们的地球</h2>-->
                        <h2 class="" >UNGC 联合国契约</h2>
                    </div>
                    <div>
                        <p >2023年10月，在中国上海举行的“加速前进”CEO圆桌会议上，特雷通集团创始人兼CEO Simon Lichtenberg 与联合国全球契约组织（UNGC）副秘书长兼执行主任 Sanda Ojiambo 女士会面，探讨企业在全球可持续发展中的责任与机遇。</p>
                        <p >作为国内最早加入联合国全球契约组织（UNGC）的企业之一，特雷通集团于2023年成功完成青年专业人才SDG创新加速器项目，并于2024年顺利通过气候雄心企业加速器（CAA）项目，持续深化可持续发展实践。</p>
                    </div>
                </div>
            </div>
            <swiper class="left swiper-box animate opacityIn"  :options="swiperOptions1" >
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_02_01.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_02_02.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_02_03.jpg" alt="csr1">
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="csr-2">
            <swiper class="left swiper-box animate opacityIn"  :options="swiperOptions1" >
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_03_01.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_03_02.jpg" alt="csr1">
                    </div>
                </swiper-slide>
            </swiper>
            <div class="right">
                <div class="animate fadeInRight">
                  <div class="row-1 ">
                    <h2 class="" style="width: 100%;text-align: center">SBTi 科学碳目标倡议</h2>
                  </div>
                    <p>2024年5月，特雷通成功通过 SBTi 官方验证，成为中国首家获此认证的家具企业。这一里程碑标志着特雷通在气候行动领域迈出了重要一步，坚定践行基于科学的碳减排和可持续发展承诺。</p>
<!--                    <p><router-link  :to="{ path: '/pdf', query: { file: 'road_map.pdf' } }" style="color: #333;text-decoration: underline">特雷通集团气候积极行动进程年度披露</router-link></p>-->
                    <p><a  href="https://www.simonli.cn/tech.html" style="color: #333;text-decoration: underline">特雷通集团气候积极行动进程年度披露</a></p>
                </div>
            </div>
        </div>
<!--        <h2 class="scr-title animate fadeInUp">SBTi Committed and Approved for CO2 and other GHG<br>-->
<!--            deductionsScope 1, 2 and 3</h2>-->
<!--        <h2 class="scr-title animate fadeInUp">Trayton is the first furniture enterprise in China<br>-->
<!--            to have been validated by SBTi<br>-->
<!--            特雷通是中国首家通过SBTi验证的家具企业</h2>-->
<!--        <img class="csr-5 animate opacityIn" src="../../../assets/images/csr5.png" alt="">-->
<!--        <img class="csr-6 animate opacityIn" src="../../../assets/images/csr6.jpg" alt="">-->
        <div class="logos">
            <h2 class="scr-title animate fadeInUp">SUSTAINABILITY</h2>
            <img class="csr-7 animate opacityIn" src="../../../assets/images/csr7.jpg" alt="">
          <div class="animate fadeInUp" style="margin-bottom: 120px;line-height: 1.5">
            <p style="text-align: center"><router-link  :to="{ path: '/pdf', query: { file: '浙江特雷通家居科技集团有限公司 2024年度社会责任报告.pdf' } }" style="color: #333;text-decoration: underline">浙江特雷通家居科技集团有限公司2024年度社会责任报告</router-link></p>
            <p style="text-align: center"><router-link  :to="{ path: '/pdf', query: { file: '浙江特雷通家居科技集团有限公司2024年度温室气体排放核查报告.pdf' } }" style="color: #333;text-decoration: underline">浙江特雷通家居科技集团有限公司2024年度温室⽓体排放核查报告</router-link></p>
            <p style="text-align: center"><router-link  :to="{ path: '/pdf', query: { file: '产品碳足迹评价报告-浙江特雷通家居科技集团有限公司.pdf' } }" style="color: #333;text-decoration: underline">产品碳⾜迹评价报告-浙江特雷通家居科技集团有限公司</router-link></p>
          </div>
        </div>
        <div class="csr-2 ">
            <div class="right">
                <div class="animate fadeInLeft">
                    <h2 class="">慈善项目</h2>
                    <div class="">
                        <p >中国有1200万农村儿童缺乏接受学前教育的机会并有约2000万儿没有接受有质量的学前教育。早期教育对人的一生有至关重要的作用，这也是改善贫困和落后地区生活的最有效方式。</p>
                        <p >这就是我们创立乡村儿童早期发展教育基金(REED)的初衷，而REED基金由来自中国乃至世界各地的商业界忧秀人士捐赠支持。</p>
                        <p >REED从2014年开始在四川省凉山州布拖县山区资助3-6岁儿童的学前幼儿班，从开始的6个班级到现在，项目覆盖了60个自然村，100个幼儿班。我们通过与当地政府和教科局密切合作，对凉山州布拖县100个幼儿班的200位在岗辅导员进行培训、管理和支持，每天有超过4500名学龄前儿童在未来希望幼儿班上学，那里有稳定的年餐和高质量的早期教育一一这些都为孩子们的未来打好坚实的基础。尤其对像布县族小孩一样的少数民族儿童来说。学习普通话显得尤为重要。</p>
                    </div>
                </div>
<!--                <p class="animate fadeInRight">上海互济公益基金会是REED项目的实施团队，在当地贯彻实施”未来希幼儿班“的管理理念。在遵循国家教育部关于学前班的指导方针的前提下，通过打造现代的以儿童为中心的早期教育来提高偏远贫地区的学前班教学质量。我们也很高兴能和上海互济基金会密合作，正是他们在当地现场工作中指导老师，帮助孩子和家长们。</p>-->
<!--                <p class="animate fadeInRight">然而，还有更多儿童需要这样的支持，我们渴望態够给更多的孩子带来更高品质的早期教育。我们欢迎更多的政府机构、合作伙伴、家长和社区组织来一起致力于偏远地区的幼儿教育。</p>-->
            </div>
            <swiper class="left swiper-box animate opacityIn"  :options="swiperOptions1" >
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_01.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_02.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_03.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_04.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_05.jpg" alt="csr1">
                    </div>
                </swiper-slide>
<!--                <swiper-slide >-->
<!--                    <div class="swiper-img">-->
<!--                        <img src="../../../assets/images/csr_swiper_04_06.jpg" alt="csr1">-->
<!--                    </div>-->
<!--                </swiper-slide>-->
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_07.jpg" alt="csr1">
                    </div>
                </swiper-slide>

                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_08.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_09.jpg" alt="csr1">
                    </div>
                </swiper-slide>+
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_10.jpg" alt="csr1">
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import VuePdf from 'vue-pdf';
    export default {
        name: 'CsrContent3',
        data () {
            return {
                swiperOptions1: {
                    pagination: '.swiper-pagination-1',
                    paginationClickable :true,
                    autoplayDisableOnInteraction : false,
                    loop: true,
                    autoplay : 3000,
                    speed: 1000,
                    effect : 'fade',
                }
            }
        },
      mounted() {
        // this.loadPdf(this.pdfUrl);
      },
    }
</script>

<style lang="scss" scoped>
@use 'styles/common' as *;

.scr-title {
    font-family: "Regular" !important;
    font-size: 1.8vw;
    line-height: 1.5;
    text-align: center;
    @include respond-to() {
        font-size: 3.4vw;
    }
}
.row-1 {
    display: flex;
    align-items: center;
    @include respond-to() {
      display: block;
      text-align: center;
    }
    img {
        margin-right: 7vw;
        @include respond-to() {
            margin-right: 0;
            margin-bottom: 3vw;
        }
    }
    h2 {
        margin: 0 0 0 0 !important;
      @include respond-to() {
        margin: 0 0 7vw 0 !important;
      }
    }
}
.csr1 {
    display: block;
    margin: 5vw auto 10vw;
    width: 62.5%;
}
.csr-2 {
    //margin-bottom: 5vw;
    display: flex;
    flex-wrap: nowrap;
    background: #f4f3ee;
    @include respond-to() {
        display: block;
    }
    .left {
        width: 50%;
        @include respond-to() {
            width: 100%;
        }
        img {
            width: 100%;
            object-fit: cover;
        }
    }
    .right {
        box-sizing: border-box;
        padding: 7vw 7% 0 7%;
        width: 50%;
        h2 {
            margin-bottom: 3vw;
            font-size: 2vw;
            text-align: center;
            @include respond-to() {
                margin: 6vw 0 8vw 0;
                font-size: 4vw;
            }
        }
        @include respond-to() {
            padding: 7vw 7% 7vw 7%;
            width: 100%;
        }
        img {
            width: 7vw;
        }
        p {
            margin-top: 2vw;
            //font-size: 0.938vw;
            font-size: 0.738vw;
            line-height: 2;
            @include respond-to() {
                font-size: 10px;
            }
        }
    }
}
.csr-5 {
    display: block;
    margin: 5vw auto;
    width: 62.5%;
}
.csr-6 {
    display: block;
    margin: 5vw auto;
    width: 84%;
}
.csr-7 {
    display: block;
    margin: 0 auto 1vw;
    width: 62.5%;
    @include respond-to {
        width: 90%;
    }
}
.logos {
    margin: 7vw auto 0;
}
</style>

